import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import StyledAgencyField from './MaskField.styles';
export default function AgencyField({
  name,
  value,
  control,
  width,
  height,
  label,
  mask,
}) {
  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            <InputMask mask={mask} maskChar="" value={value} {...field}>
              {(inputProps) => (
                <StyledAgencyField
                  id="agency"
                  label={label}
                  variant="filled"
                  {...inputProps}
                  width={width}
                  height={height}
                />
              )}
            </InputMask>
          </>
        )}
      ></Controller>
    </>
  );
}

AgencyField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  control: PropTypes.any.isRequired,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  mask: PropTypes.string.isRequired,
};
